import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "PropertyListPage" */
	'pages/intervention/Property/PropertyListPage'));

export default [{ component, exact: true, path: '/properties' }];